import React, { memo } from "react"
import { Animated } from "react-animated-css"
import { Typography } from "antd"

const { Title } = Typography

const OdooTopSection = ({ headerData, data }) => {
  const bgImage = data.Odooimg.childImageSharp.fluid.src

  return (
    <div
      className="top-section"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="box-wrapper text-and-form-container" style={{ gridTemplateColumns: '1fr', textAlign: 'center' }}>
        <div className="information">
          <Animated
            animationIn="fadeInUp"
            animationInDuration={500}
            animationInDelay={300}
            isVisible={true}
          >
            <Title>{headerData.title}</Title>
            {headerData.para && (
              <>
                <br />
                <p>{headerData.para}</p>
              </>
            )}
          </Animated>
        </div>
      </div>
    </div>
  )
}

export default memo(OdooTopSection)
